import config from '../config';
import { request } from '../utils/request';

// const devtoolDomain = `http://127.0.0.1:7001/${config.apiRouter.devtool}`;
// const devtoolDomain = `http://203.195.171.140:7001/${config.apiRouter.devtool}`;
const devtoolDomain = `${config.host}${config.apiRouter.devtool}`;

export default {
  checkDevtoolLogin (params) {
    return request({
      method: 'GET',
      hideLoading: true,
      url: `${devtoolDomain}/checkLogin`,
      params,
      timeout: 60000,
    });
  },

  switchDevtoolLogin (params) {
    return request({
      method: 'GET',
      url: `${devtoolDomain}/switchLogin`,
      params,
      timeout: 60000,
    });
  },

  createWeshopTask (data, params) {
    return request({
      method: 'POST',
      url: `${devtoolDomain}/createWeshopTask`,
      data,
      params,
      timeout: 60000,
    });
  },

  getWeshopTaskInfo (params) {
    return request({
      method: 'GET',
      url: `${devtoolDomain}/getWeshopTaskInfo`,
      params,
      hideLoading: true,
      timeout: 60000,
    });
  },

  getWeshopTaskQrcode (params) {
    return request({
      method: 'GET',
      url: `${devtoolDomain}/getWeshopTaskQrcode`,
      params,
      timeout: 60000,
    });
  },

  restartWeshopTask (params) {
    return request({
      method: 'GET',
      url: `${devtoolDomain}/restartWeshopTask`,
      params,
      timeout: 60000,
    });
  },

};
